/* tslint:disable:no-small-switch */
import { OverlayActions, PlacementActions } from './index';
import { CommonPlacement } from '../components/common-placement/common-placement.component';
export enum PlacementTemplateActions{
  showOverlay='SHOW_OVERLAY',
  redirectToUrl='REDIRECT',
  breadApply='BREAD_APPLY',
  redirectInternal='REDIRECT_INTERNAL',
}
export function placementActionReducer(actionType: string, actionData: any, placement: CommonPlacement){
  switch(actionType){
    case PlacementTemplateActions.showOverlay:
      return OverlayActions.showOverlay({
        actionContentId: actionData.actionContentId,
        placementConfig: placement.placementConfig,
        brandPresentmentConfig: placement.brandPresentmentConfig,
        placementMetaData: placement.placementMetaData
      });

    case PlacementTemplateActions.redirectToUrl:
      return PlacementActions.redirectToUrl({
        placementConfig: placement.placementConfig,
        placementMetaData: placement.placementMetaData,
        targetUrl: actionData.actionTargetUrl,
        target: '_blank'
      });

    case PlacementTemplateActions.redirectInternal:
      return PlacementActions.redirectToUrl({
        placementConfig: placement.placementConfig,
        placementMetaData: placement.placementMetaData,
        targetUrl: actionData.actionTargetUrl,
        target: '_self'
      });

    case PlacementTemplateActions.breadApply:
      return OverlayActions.breadApply();

    default:
      return undefined;
  }
}
